import { computed, Injectable, inject, signal } from '@angular/core';
import { EmployeeService } from '@coin/shared/auth/data-access';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EmployeeDirect } from '@coin/shared/core/util-models-v2';

const STATE_DEFAULTS: DirectsStateModel = {
  inCompanyManagerDirects: [],
  lineManagerDirects: []
};
export interface DirectsStateModel {
  inCompanyManagerDirects: EmployeeDirect[];
  lineManagerDirects: EmployeeDirect[];
}
// Auto-migrated from NGXS
@Injectable({ providedIn: 'root' })
export class DirectsState {
  private employeeService = inject(EmployeeService);

  private directsStateModel = signal<DirectsStateModel>(STATE_DEFAULTS);

  public hasDirects = computed(
    () =>
      !!(
        this.directsStateModel().inCompanyManagerDirects?.length || this.directsStateModel().lineManagerDirects?.length
      )
  );

  public isLineManager = computed(() => !!this.directsStateModel().lineManagerDirects?.length);

  public inCompanyManagerDirects = computed(() => this.directsStateModel().inCompanyManagerDirects);

  public lineManagerDirects = computed(() => this.directsStateModel().lineManagerDirects);

  static sortEmployees(employees: EmployeeDirect[]): EmployeeDirect[] {
    return employees.sort((a, b) => a?.firstname?.localeCompare(b?.firstname));
  }

  getDirects(userId: string): Observable<unknown> {
    return forkJoin([
      this.employeeService.getInCompanyManagerDirectsForEmployee(userId),
      this.employeeService.getLineManagerDirectsForEmployee(userId)
    ]).pipe(
      map(([inCompanyManagerDirects, lineManagerDirects]) => [
        DirectsState.sortEmployees(inCompanyManagerDirects),
        DirectsState.sortEmployees(lineManagerDirects)
      ]),
      map(([inCompanyManagerDirects, lineManagerDirects]) =>
        this.directsStateModel.update(state => ({ ...state, inCompanyManagerDirects, lineManagerDirects }))
      )
    );
  }

  clearDirects(): void {
    this.directsStateModel.update(state => ({ ...state, inCompanyManagerDirects: [], lineManagerDirects: [] }));
  }
}
